const initialState = false;

export const setUpdateFeedback = (state, { payload }) => payload;

export default initialState;
